module.exports = __webpack_public_path__ + "img/sec22.323e4f95.jpg";